import { render, staticRenderFns } from "./editCityArea.vue?vue&type=template&id=6b99dfc8&scoped=true"
import script from "./editCityArea.vue?vue&type=script&lang=js"
export * from "./editCityArea.vue?vue&type=script&lang=js"
import style0 from "./editCityArea.vue?vue&type=style&index=0&id=6b99dfc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b99dfc8",
  null
  
)

export default component.exports